export function canDeleteGln(item) {
  return !!item && item.status === "review";
}

export function filterVisibleGlns(items) {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.filter((item) => item.status !== "deleted");
}
